module.exports = __webpack_public_path__ + "static/img/ID.2dfdab22.jpg";